"use strict";
exports.__esModule = true;
exports.ParticipantSubAccountList = void 0;
var SubAccountType_1 = require("../common/SubAccountType");
exports.ParticipantSubAccountList = [
    SubAccountType_1.SubAccountType.participantStandard,
    SubAccountType_1.SubAccountType.participantOutsideInvestment,
    SubAccountType_1.SubAccountType.participantCash,
];
